import { connect } from 'react-redux';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { ProductCardLayoutType } from '../../common/models/product';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import { getSelected } from '../../single-choice/utils/selection';
import { BAGGAGE_SERVICE } from '../../products';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = BAGGAGE_SERVICE;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  title: 'baggageServiceTitle',
  persuasionContent: 'baggageServicePersuasionContent',
  readMoreContent: 'baggageServiceReadMoreModalContent'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'baggageServiceAdditionalInformation',
  abstractContent: 'baggageServiceAbstract',
  upSell: 'baggageServiceUpSellText'
};
const smallCardTranslations = {
  ...sharedTexts,
  abstractContent: 'baggageServiceAbstractSmallCard',
  upSell: 'baggageServiceUpSellTextSmallCard'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: smallCardTranslations
};
const BaggageService = ({
  className,
  form,
  isSelected,
  order,
  productCode,
  productPosition,
  sellSpecification,
  layoutType = MAIN_CARD_LAYOUT
}) => {
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productCode,
    productPosition,
    productType: 'traveler',
    sellSpecification,
    texts
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(SmallCardLayout, {
        className: className,
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        className: className,
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, {
  form
}) => ({
  isSelected: getSelected(BAGGAGE_SERVICE.name, form)(state)
});
export default connect(mapStateToProps)(BaggageService);
//# sourceMappingURL=BaggageService.js.map